export default __webpack_public_path__ + "static/media/step1@3x.2f8342da.jpg";